exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination__item[data-v-dd8abf42]{margin-left:8px;margin-right:8px;color:#343434}.pagination__item.current[data-v-dd8abf42]{color:#ff8100}#paginationInput[data-v-dd8abf42]{border:1px solid #D9D9D9;border-radius:19px;padding:9px;font-size:14px;text-align:center;width:16px;line-height:11px;height:16px;appearance:none;-webkit-appearance:none;-moz-appearance:textfield;margin:0 3px}#paginationInput[data-v-dd8abf42]::-webkit-outer-spin-button,#paginationInput[data-v-dd8abf42]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}\n", ""]);

// exports
